import HiddenValueDots from '@components/v2/ui/HiddenValueDots/HiddenValueDots';
import { Box } from '@mui/material';

const HideValueTag = () => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <HiddenValueDots />
  </Box>
);

export default HideValueTag;
